// export default {
//   API_URL: 'http://localhost:5010',
//   redirectUri: 'http://localhost:8080',
// }

// export default {
//   API_URL: 'https://staging-ids.bitianxia.net',
//   redirectUri: 'https://staging-sgb.bitianxia.net',
// }

// export default {
//   API_URL: 'https://ids.bitianxia.net',
//   redirectUri: 'https://osgb.bitianxia.net',
// }

const API_BY_HOST = {
  'localhost': 'http://localhost:5010',
  'staging-sgb.bitianxia.net': 'https://staging-ids.bitianxia.net',
  'sgb.bitianxia.net': 'https://ids.bitianxia.net',
};

const REDIRECT_URL = window.location.origin;
const API_URL =
  API_BY_HOST[window.location.hostname] ?? 'https://ids.bitianxia.net'; // fallback

export default {
  API_URL: API_URL,
  redirectUri: REDIRECT_URL,
}